import { Redirect, Route, Switch } from '@jupiter/plugin-runtime/router';
import routesConfig from '@/router-config';
import ConnectionRelativePaths from '@/router-config/paths';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Routes = function Routes() {
  return /*#__PURE__*/_jsxs(Switch, {
    "data-e2e": "fc695d32-7e98-3bf9",
    children: [routesConfig.map(function (_ref) {
      var path = _ref.path,
        component = _ref.component;
      return /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: path,
        component: component
      }, path);
    }), /*#__PURE__*/_jsx(Redirect, {
      from: "/mcn",
      to: ConnectionRelativePaths.FIND_MCN
    }), /*#__PURE__*/_jsx(Redirect, {
      to: ConnectionRelativePaths.CREATOR_MARKETPLACE
    })]
  });
};
export default Routes;